module.exports = __webpack_public_path__ + "img/TK@2x.2ecc615d.png";